import {ref} from 'vue';

export default {
    install: (app, options) => {
        const fileRequestCompanies = ref([]);

        const loadFileRequestParameters = (status = null) => {
            window.lazy_axios.get(`/file-requests/parameters/?status=${status}`)
                .then((response) => {
                    if (response.data.companies) {
                        fileRequestCompanies.value = response.data.companies;
                    }
                });
        };

        app.provide('fileRequestCompanies', fileRequestCompanies);
        app.provide('loadFileRequestParameters', loadFileRequestParameters);
    },
}
